import {
  GET_EXCEL_DOWNLOAD_SALE,
  GET_EXCEL_DOWNLOAD_VEHICLE,
  GET_EXCEL_DOWNLOAD_LEAD,
  GET_EXCEL_DOWNLOAD_INVESTMENT_LEAD,
  GET_EXCEL_DOWNLOAD_SALE_FAIL,
  GET_EXCEL_DOWNLOAD_LEAD_FAIL,
  GET_EXCEL_DOWNLOAD_INVESTMENT_LEAD_FAIL,
  GET_EXCEL_DOWNLOAD_VEHICLE_FAIL,
  GET_EXCEL_DOWNLOAD_SALE_SUCCESS,
  GET_EXCEL_DOWNLOAD_VEHICLE_SUCCESS,
  GET_EXCEL_DOWNLOAD_LEAD_SUCCESS,
  GET_EXCEL_DOWNLOAD_INVESTMENT_LEAD_SUCCESS,
  GET_EXCEL_DOWNLOAD_INSPECTION_DOCUMENT_FAIL,
  GET_EXCEL_DOWNLOAD_INSPECTION_DOCUMENT_SUCCESS,
  GET_EXCEL_DOWNLOAD_INSPECTION_DOCUMENT,
  GET_EXCEL_DOWNLOAD_CHALLAN,
  GET_EXCEL_DOWNLOAD_CHALLAN_SUCCESS,
  GET_EXCEL_DOWNLOAD_CHALLAN_FAIL,
  GET_EXCEL_DOWNLOAD_INSPECTION_BOOKING_SUCCESS,
  GET_EXCEL_DOWNLOAD_INSPECTION_BOOKING,
  GET_EXCEL_DOWNLOAD_INSPECTION_BOOKING_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  excelDownloadLead: [],
  excelDownloadInvestmentLead: [],
  excelDownloadSale: [],
  excelDownloadVehicle: [],
  excelDownloadInspectionDocument: [],
  excelDownloadChallan: [],
  excelDownloadInspectionBooking: [],
  error: {},
  loading: false,
}

const ExcelDownload = (state = INIT_STATE, action) => {
  switch (action.type) {
    // ExcelDownload - This line cannot be edited or removed
    case GET_EXCEL_DOWNLOAD_SALE:
    case GET_EXCEL_DOWNLOAD_CHALLAN:

    case GET_EXCEL_DOWNLOAD_VEHICLE:
    case GET_EXCEL_DOWNLOAD_LEAD:
    case GET_EXCEL_DOWNLOAD_INVESTMENT_LEAD:
    case GET_EXCEL_DOWNLOAD_INSPECTION_DOCUMENT:
    case GET_EXCEL_DOWNLOAD_INSPECTION_BOOKING:
      return {
        ...state,
        loading: true,
      }

    case GET_EXCEL_DOWNLOAD_SALE_FAIL:
    case GET_EXCEL_DOWNLOAD_CHALLAN_FAIL:

    case GET_EXCEL_DOWNLOAD_LEAD_FAIL:
    case GET_EXCEL_DOWNLOAD_INVESTMENT_LEAD_FAIL:
    case GET_EXCEL_DOWNLOAD_VEHICLE_FAIL:
    case GET_EXCEL_DOWNLOAD_INSPECTION_DOCUMENT_FAIL:
    case GET_EXCEL_DOWNLOAD_INSPECTION_BOOKING_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case GET_EXCEL_DOWNLOAD_SALE_SUCCESS:
      return {
        ...state,
        excelDownloadSale: action.payload,
        error: {},
        loading: false,
      }

    case GET_EXCEL_DOWNLOAD_VEHICLE_SUCCESS:
      return {
        ...state,
        excelDownloadVehicle: action.payload,
        error: {},
        loading: false,
      }

    case GET_EXCEL_DOWNLOAD_LEAD_SUCCESS:
      return {
        ...state,
        excelDownloadLead: action.payload,
        error: {},
        loading: false,
      }
    case GET_EXCEL_DOWNLOAD_INVESTMENT_LEAD_SUCCESS:
      return {
        ...state,
        excelDownloadInvestmentLead: action.payload,
        error: {},
        loading: false,
      }
    case GET_EXCEL_DOWNLOAD_INSPECTION_DOCUMENT_SUCCESS:
      return {
        ...state,
        excelDownloadInspectionDocument: action.payload,
        error: {},
        loading: false,
      }
    case GET_EXCEL_DOWNLOAD_CHALLAN_SUCCESS:
      return {
        ...state,
        excelDownloadChallan: action.payload,
        error: {},
        loading: false,
      }
    case GET_EXCEL_DOWNLOAD_INSPECTION_BOOKING_SUCCESS:
      return {
        ...state,
        excelDownloadInspectionBooking: action.payload,
        error: {},
        loading: false,
      }
    default:
      return state
  }
}

export default ExcelDownload
